import {
  CommonParamsType,
  CommonSuccessResponse,
} from "constants/types/common";
import { WarehouseResponseType } from "constants/types/warehouse";
import { useMemo } from "react";
import useSWR from "swr";
import { serialize } from "utils/validation/string";

export const getWarehouseListKey = (params?: CommonParamsType) => {
  return `/warehouse?${serialize({ ...params })}`;
};

export const useWarehouses = (params?: CommonParamsType) => {
  const {
    data,
    error,
    isLoading,
    mutate,
  }: {
    data: CommonSuccessResponse<WarehouseResponseType[]> | undefined;
    error: any;
    isLoading: boolean;
    mutate: any;
  } = useSWR(getWarehouseListKey(params), { refreshInterval: 0 });

  const pagination = data?.meta;
  const warehouses = data?.data;

  return {
    warehouses,
    pagination,
    error,
    isLoading,
    mutate,
  };
};

export const useListWarehouse = () => {
  const {
    data,
    error,
    isLoading,
    mutate,
  }: {
    data: CommonSuccessResponse<WarehouseResponseType[]> | undefined;
    error: any;
    isLoading: boolean;
    mutate: any;
  } = useSWR("/warehouse/all", { refreshInterval: 0 });

  const warehouses = data?.data;

  const warehouseOptions = useMemo(
    () =>
      warehouses?.map((warehouse) => ({
        label: warehouse.name,
        value: warehouse.id,
      })),
    [warehouses],
  );

  return {
    warehouses,
    warehouseOptions,
    error,
    isLoading,
    mutate,
  };
};
